import React from 'react';
import { FuelButton, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { useNavigate } from 'react-router-dom';
import StepSummary from '@components/ui/StepSummary';
import useAmplitude from '@hooks/useAmplitude';
import * as Styled from './JourneyOnboardingStyles';
import { JourneyOnboardingInterface } from './JourneyOnboardingTypes';
import { steps } from './JourneyOnboarding.data';

function JourneyOnboarding({ isMobile }: JourneyOnboardingInterface) {
  const { amplitudeEvent } = useAmplitude();
  const navigate = useNavigate();

  const handlePaymentDoc = () => {
    amplitudeEvent('payment_doc_list_viewed', {
      source: 'empty-viagem-monitoramento',
    });
    navigate('/dados-pagamento');
  };

  return (
    <Styled.Content>
      <FuelFlex
        defaultProps={{
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <FuelTypography weight="bold" size="heading-lg" color="neutral-strong">
          Monitore suas viagens até a entrega
        </FuelTypography>
        <FuelTypography
          weight="medium"
          size="body-md"
          color="neutral-default"
          spacingTop={8}
        >
          Quando você tiver viagens criadas, poderá acompanha-las aqui
        </FuelTypography>
      </FuelFlex>

      <Styled.WrapperCardList>
        {steps.map((step, index, array) => (
          <>
            <StepSummary
              iconName={step.icon}
              isMobile={isMobile}
              title={step.title}
              description={step.description}
            />
            {index + 1 !== array.length && (
              <Styled.ArrowIcon name="arrow-right" size="huge" />
            )}
          </>
        ))}
      </Styled.WrapperCardList>

      <Styled.WrapperButton>
        <FuelButton
          variant="primary"
          size="large"
          fullWidth
          onClick={handlePaymentDoc}
        >
          Cadastrar dados
        </FuelButton>
      </Styled.WrapperButton>
    </Styled.Content>
  );
}

export default JourneyOnboarding;
